import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

/**
 * Prompts before leaving a page with unsaved edits, matching the modal forms' useDirtyFormGuard.
 * useBlocker covers in-app exits (sidebar links, browser back/forward) which only the data router
 * can intercept; the beforeunload handler covers refresh / tab close, which useBlocker cannot reach.
 */
export function useUnsavedChangesGuard(when: boolean): void {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => when && currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    if (blocker.state !== 'blocked') return;
    if (window.confirm('You have unsaved changes. Discard?')) blocker.proceed();
    else blocker.reset();
  }, [blocker]);

  useEffect(() => {
    if (!when) return;
    const handler = (e: BeforeUnloadEvent) => { e.preventDefault(); e.returnValue = ''; };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [when]);
}
